const vO123 = {
  UNCOMMON: 0,
  RARE: 1,
  EPIC: 2,
  LEGENDARY: 3,
  RELIC: 4,
  CONTRABAND: 5,
  UNOBTAINABLE: 6,
  NFT: 7
};
module.exports = vO123;